import ThemeWrapper from 'Map/configurer/styleOptionInitialization/themeWrapper';

export default (options, styleResolverFactory) => {
    const styleResolverOptions = {
        ...options,
        unwrapedTheme: options.theme.unwrap()
    };

    switch (styleResolverOptions.theme.getType()) {
    case ThemeWrapper.TYPE.URL:
        return styleResolverOptions.unwrapedTheme.url;
    case ThemeWrapper.TYPE.OBJECT:
        return styleResolverOptions.unwrapedTheme.styleObject;
    case ThemeWrapper.TYPE.RESOLVED_SCHEMA:
        return styleResolverFactory(styleResolverOptions);
    default:
        throw new Error('Invalid theme type specified.');
    }
};



// WEBPACK FOOTER //
// ./map/tier/styleParts/initializeStyleOption.js